import createIcon from '../../createIcon';

/**
 * @component @name Numbers
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSAxMEwyMSA4SDE3TDE4IDRIMTZMMTUgOEgxMUwxMiA0SDEwTDkgOEg1TDQuNSAxMEg4LjVMNy41IDE0SDMuNUwzIDE2SDdMNiAyMEg4TDkgMTZIMTNMMTIgMjBIMTRMMTUgMTZIMTlMMTkuNSAxNEgxNS41TDE2LjUgMTBIMjAuNVpNMTMuNSAxNEg5LjVMMTAuNSAxMEgxNC41TDEzLjUgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Numbers = createIcon('Numbers', [
  [
    'path',
    {
      d: 'M20.5 10L21 8H17L18 4H16L15 8H11L12 4H10L9 8H5L4.5 10H8.5L7.5 14H3.5L3 16H7L6 20H8L9 16H13L12 20H14L15 16H19L19.5 14H15.5L16.5 10H20.5ZM13.5 14H9.5L10.5 10H14.5L13.5 14Z',
      key: '1plmfb',
    },
  ],
]);

export default Numbers;
